import { reactive } from '@vue/composition-api';
import { PhotoModalWithEditState } from '@/models/photoModal';
import {
  EmergencyResponseTeamReportPhotoExt,
} from '@/models/externalReports/emergencyResponseTeam/emergencyResponseTeamReport';
import { dtFormat } from '@/lib/dateHelper';

export interface UsePhotoModalResult {
  photoModalState: PhotoModalWithEditState;
  showPhotoModal: (photoType: string, photos: EmergencyResponseTeamReportPhotoExt[]) => void;
  refreshPhotos: (photos: EmergencyResponseTeamReportPhotoExt[]) => void;
  hidePhotoModal: () => void;
}
export function usePhotoModal(): UsePhotoModalResult {
  const photoModalState = reactive<PhotoModalWithEditState>({
    shouldShowPhotoModal: false,
    title: '',
    photos: [],
  });

  const refreshPhotos = (photos: EmergencyResponseTeamReportPhotoExt[]): void => {
    const newPhotos = photos.map((photo) => ({
      id: photo.id,
      photoTitle: photo.dispOrder + '. ' + dtFormat(photo.ts),
      savedImage: photo.savedImage,
      comment: photo.comment ?? '',
      type: photo.photoType,
      order: photo.dispOrder,
      lon: photo.lon,
      lat: photo.lat,
    }));
    newPhotos.sort((a, b) => a.order - b.order);
    photoModalState.photos = [...newPhotos];
  };

  const showPhotoModal = (photoType: string, photos: EmergencyResponseTeamReportPhotoExt[]) => {
    photoModalState.title = photoType + '写真';
    refreshPhotos(photos);
    photoModalState.shouldShowPhotoModal = true;
  };
  const hidePhotoModal = () => {
    photoModalState.shouldShowPhotoModal = false;
    photoModalState.title = '';
    photoModalState.photos = [];
  };

  return {
    photoModalState,
    showPhotoModal,
    refreshPhotos,
    hidePhotoModal,
  };
}
